import ContentLoader from "@funded-here-interface/common/src/components/ContentLoader/ContentLoader";
import { IconPhotoDollar, IconSignature, IconCoin, IconInfoHexagon } from "@tabler/icons-react";
import { FC, ReactNode, Suspense } from "react";

import NavBar from "../../components/NavBar/NavBar";
import { useStyles } from "./SalesSupportLayout.styles";

interface IProps {
  content: ReactNode;
}

const SalesSupportLayout: FC<IProps> = ({ content }) => {
  const { classes } = useStyles();

  const menus = [
    {
      label: "Onboarding",
      path: "/onboarding",
      icon: <IconSignature />,
    },
    {
      label: "Collaboration Proposal",
      path: "/sales-support/application",
      icon: <IconPhotoDollar />,
    },
    {
      label: "Collection Accounts",
      path: "/merchant-collection-accounts",
      icon: <IconCoin />,
    },
    {
      label: "Funding Limit Details",
      path: "/funding-limit-details-csc",
      icon: <IconInfoHexagon />,
    },
  ];

  return (
    <div className={classes.mainContainer}>
      <NavBar menus={menus} />
      <div style={{ paddingBottom: "30px" }} className={classes.hero}>
        <Suspense fallback={<ContentLoader />}>{content}</Suspense>
      </div>
    </div>
  );
};

export default SalesSupportLayout;
